export const TYPY_PRISTUPU = Object.freeze({
  HLAVNY_ADMIN: "HLAVNY_ADMIN",
  CIASTOCNY_ADMIN: "CIASTOCNY_ADMIN",
  UZIVATEL: "UZIVATEL"
});

export const UZIVATELSKE_OPRAVNENIA = Object.freeze({
  VSETKO: "VSETKO",
  UVERY: "UVERY",
  KT: "KT",
  POISTENIE: "POISTENIE"
});

const HLAVNY_ADMIN_EMAIL = "admin@fincloud.sk";

function jeHlavnyAdminEmail(email) {
  return String(email || "").trim().toLowerCase() === HLAVNY_ADMIN_EMAIL;
}

export function normalizujPristup(pristup, user = {}) {
  const typ = jeHlavnyAdminEmail(user?.email)
    ? TYPY_PRISTUPU.HLAVNY_ADMIN
    : Object.values(TYPY_PRISTUPU).includes(pristup?.typ)
      ? pristup.typ
      : user?.roles?.includes("admin") || user?.roles?.includes("partial_admin")
        ? TYPY_PRISTUPU.CIASTOCNY_ADMIN
        : TYPY_PRISTUPU.UZIVATEL;

  if (typ === TYPY_PRISTUPU.HLAVNY_ADMIN) {
    return {
      typ,
      adminOpravnenia: {
        adminPreUzivatelov: true,
        adminPreProdukt: true
      },
      uzivatelskeOpravnenia: pristup?.uzivatelskeOpravnenia?.length
        ? pristup.uzivatelskeOpravnenia
        : [{ kod: UZIVATELSKE_OPRAVNENIA.VSETKO, platneDo: null }]
    };
  }

  if (typ === TYPY_PRISTUPU.CIASTOCNY_ADMIN) {
    const nemaNoveAdminOpravnenia =
      !pristup?.adminOpravnenia &&
      (user?.roles?.includes("admin") || user?.roles?.includes("partial_admin"));

    return {
      typ,
      adminOpravnenia: {
        adminPreUzivatelov: nemaNoveAdminOpravnenia
          ? true
          : !!pristup?.adminOpravnenia?.adminPreUzivatelov,
        adminPreProdukt: !!pristup?.adminOpravnenia?.adminPreProdukt
      },
      uzivatelskeOpravnenia: pristup?.uzivatelskeOpravnenia?.length
        ? pristup.uzivatelskeOpravnenia
        : [{ kod: UZIVATELSKE_OPRAVNENIA.VSETKO, platneDo: null }]
    };
  }

  return {
    typ: TYPY_PRISTUPU.UZIVATEL,
    adminOpravnenia: {
      adminPreUzivatelov: false,
      adminPreProdukt: false
    },
    uzivatelskeOpravnenia: pristup?.uzivatelskeOpravnenia?.length
      ? pristup.uzivatelskeOpravnenia
      : [{ kod: UZIVATELSKE_OPRAVNENIA.VSETKO, platneDo: null }]
  };
}

export function maAdminPreUzivatelov(user) {
  const pristup = normalizujPristup(user?.pristup, user);
  return pristup.typ === TYPY_PRISTUPU.HLAVNY_ADMIN ||
    (pristup.typ === TYPY_PRISTUPU.CIASTOCNY_ADMIN && !!pristup.adminOpravnenia.adminPreUzivatelov);
}

export function maAdminPreProdukt(user) {
  const pristup = normalizujPristup(user?.pristup, user);
  return pristup.typ === TYPY_PRISTUPU.HLAVNY_ADMIN ||
    (pristup.typ === TYPY_PRISTUPU.CIASTOCNY_ADMIN && !!pristup.adminOpravnenia.adminPreProdukt);
}

export function maAdminPristup(user) {
  return maAdminPreUzivatelov(user) || maAdminPreProdukt(user);
}
